const NEXT_PUBLIC_BASE_PATH = process.env.NEXT_PUBLIC_BASE_PATH
export const isProductionEnvironment = () =>
  ['https://app.omnea.co', 'https://app.us.omnea.co'].includes(NEXT_PUBLIC_BASE_PATH || '')

export const isStagingEnvironment = () =>
  ['https://app.omnea-staging.co', 'https://app.us.omnea-staging.co'].includes(NEXT_PUBLIC_BASE_PATH || '')
